<template>
  <DefaultLayout>
    <div>
      <div class="container position-absolute zindex-5" style="width: 600px; left: 50%; top: 50%; transform: translate(-50%, -50%);">
        <div v-if="error" class="card p-4">
          <div style="padding: 10px 0; float: left; width: 100%;">
            <img src="~resonance-theme/src/assets/img/apps/networks-logo-light.svg" alt="logo" style="float: left; width: 180px; margin-bottom: 20px;" />
          </div>
          <p class="fw-normal fs-4 text-secondary mb-4 align-left" style="/*width: 400px;*/">
            {{ message }}
          </p>
          <button class="btn btn-primary" style="padding: 0.425rem 1.7rem !important; width: fit-content !important;" @click="contactNow">
            {{ $t('contact-support') }}
          </button>
        </div>
        <div v-else>
          <div class="card p-4 shadow-lg" style="text-align: center;">
            <div class="py-3 mt-3 mb-n4">
              <img class="d-none d-md-none d-lg-inline-block" src="~resonance-theme/src/assets/img/brand/resonance-logo-text.svg" style="max-width: 320px; margin-bottom: 50px;"/>
              <img class="d-lg-none d-xl-none" src="~resonance-theme/src/assets/img/brand/resonance-logo-text.svg" style="max-width: 65%; margin-bottom: 40px;"/>
              <h3 class="typing mb-1">{{ message }}</h3>
              <div style="height: 130px;">
                <lottie-player
                  autoplay
                  loop
	                speed="2.5"
                  src="/img/animations/custom_loader.json"
                  >
                </lottie-player>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>
<script>
import DefaultLayout from '@/views/layouts/default';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    DefaultLayout,
  },
  data() {
    let error = this.$route.query.error;
    let message = error ? this.$t('there-was-a-problem-processing-your-request') : this.$t('signingIn');
    return { message, error };
  },
  computed: {
    ...mapState({
      nextURL: state => state.auth.nextURL,
    }),
  },
  mounted() {
    let authCode = this.$route.query.code;
    if (authCode && !this.error) this.login(authCode);
    else if (this.error) {
      this.message = this.$t('there-was-a-problem-processing-your-request');
    }
  },
  methods: {
    ...mapActions({
      signIn: 'signIn',
    }),
    async login(authCode) {
      await this.signIn(authCode);

      // send the users to the next URL after login was succesful
      this.$router.push(this.nextURL || '/');
    },
    contactNow() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('open-support-modal');
      }
      this.$bus.emit('show-support-form');
    },
  },
};
</script>
<style>
.typing {
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  /*border-right: .15em solid orange;  The typwriter cursor */
  white-space: nowrap; /* Keeps the content on a single line */
  margin: 0 auto; /* Gives that scrolling effect as the typing happens */
  letter-spacing: .02em; /* Adjust as needed */
  animation:
    typing 4s steps(45, end),
    blink-caret .50s step-end infinite;
}
/* The typing effect */
@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}
</style>
